<template>
  <dialog-component
    ref="changelogsDialogRef"
    persistent
    size="lg"
    @cancel="changelogsDialogRef.hide()"
  >
    <template #header>
      <div class="text-h5 text-weight-light bg-dark text-white q-py-md q-pl-md">
        Notes de <span class="text-secondary text-weight-medium">mise à jour</span>
      </div>
    </template>

    <q-card-section class="q-pa-none">
      <div ref="scrollTargetRef" class="scroll-container q-px-xl">
        <template v-if="loading && changelogs.length === 0">
          <changelogs-list-skeleton small />
        </template>
        <empty-list v-else-if="empty(changelogs)" title="Aucune note de mise à jour disponible" class="q-my-md" />
        <q-timeline
          v-else
          class="q-ma-none q-pa-none q-mt-xl"
        >
          <q-infinite-scroll
            :offset="50"
            :loading="loading"
            :scroll-target="scrollTargetRef"
            :initial-index="1"
            :disable="disableInfiniteScroll"
            @load="loadChangelogs"
          >
            <changelog-item
              v-for="c in changelogs"
              :key="c.id"
              :changelog="c"
              :is-new="c.id === lastUnreadId"
            />
            <q-timeline-entry color="transparent" class="change-log-timeline" />
            <template #loading>
              <div class="row justify-center q-my-md">
                <q-spinner-dots :color="$q.dark.isActive ? 'secondary' : 'primary'" size="40px" />
              </div>
            </template>
          </q-infinite-scroll>
        </q-timeline>
      </div>
    </q-card-section>
  </dialog-component>
</template>

<script setup>
  import { onMounted, ref } from 'vue'
  import EmptyList from 'src/modules/core/components/EmptyList.vue'
  import { empty } from 'src/utils/variable.js'
  import ChangelogItem from 'src/modules/changelogs/components/ChangelogItem.vue'
  import { useQuasar } from 'quasar'
  import useChangelogs from 'src/modules/changelogs/composables/useChangelogs.js'
  import { Pagination } from 'src/modules/core/helpers/pagination.js'
  import ChangelogsListSkeleton from 'src/modules/changelogs/components/ChangelogsListSkeleton.vue'
  import DialogComponent from 'src/modules/core/components/DialogComponent'

  const $q = useQuasar()

  const changelogsDialogRef = ref(null)
  const scrollTargetRef = ref(null)

  const disableInfiniteScroll = ref(false)

  const {
    changelogs,
    loading,
    lastUnreadId,
    loadChangelogs
  } = useChangelogs(Pagination.smallRowsPerPage)

  const props = defineProps({
    changelog: Object
  })

  defineExpose({ show, hide })

  onMounted(() => {
    if (props.changelog) {
      changelogs.value = [props.changelog]
      lastUnreadId.value = props.changelog.id
      disableInfiniteScroll.value = true
    } else {
      loadChangelogs(1, () => {})
    }
  })

  function show() {
    changelogsDialogRef.value.show()
  }

  function hide() {
    changelogsDialogRef.value.hide()
  }
</script>

<style lang="scss" scoped>
  .scroll-container {
    max-height: calc(100vh - 150px);
    overflow: auto;
  }
</style>
